// import React from "react";
// import { Link } from "react-router-dom";
// import { orators } from "../../utils/Orators/orators";
// import OraterCard from "../ui/OraterCard";

// const Orators = () => {
//   return (
//     <div className="flex flex-col px-4 md:px-12 py-8 items-center justify-center my-8">
//       <h1 className="text-2xl text-one md:text-3xl font-bold text-center">
//         GENT - Orators
//       </h1>
//       <p className="w-full md:w-2/3 my-2 text-center text-sm md:text-base text-slate-600">
//         Renowned experts from across the globe sharing insights and leading the
//         conversation at GENT.
//       </p>

//       <div className="flex flex-col md:flex-row cursor-default gap-6 items-center justify-center mt-4">
//         {orators.slice(0, 4).map((item, idx) => (
//           <OraterCard 
//             key={idx}
//             name={item.name}
//             about={item.about}
//             from={item.from}
//             image={item.image}
//             // link={item.link}
//           />
//         ))}
//       </div>

//       <Link to="/GENT-summit-orators">
//         <button className="bg-one text-white px-10 md:px-20 py-2 rounded-full mt-6 text-sm md:text-base">
//           View All
//         </button>
//       </Link>
//     </div>
//   );
// };

// export default Orators;


import React from "react";
import { Link } from "react-router-dom";
import { orators } from "../../utils/Orators/orators"; // Ensure this path is correct
import OraterCard from "../ui/OraterCard"; // Ensure this path is correct

const Orators = () => {
  return (
    <div className="flex flex-col px-4 md:px-12 py-8 items-center justify-center my-8">
      <h1 className="text-2xl text-one md:text-3xl font-bold text-center">
        GENT - Orators
      </h1>
      <p className="w-full md:w-2/3 my-2 text-center text-sm md:text-base text-slate-600">
        Renowned experts from across the globe sharing insights and leading the
        conversation at GENT.
      </p>

      <div className="flex flex-col md:flex-row cursor-default gap-6 items-stretch justify-center mt-4">
        {orators.slice(0, 4).map((item, idx) => (
          <OraterCard
            key={idx}
            name={item.name}
            about={item.about}
            from={item.from}
            image={item.image}
            link={item.link} // The link prop is still passed but the card itself is not a direct link
          />
        ))}
      </div>

      <Link to="/world-GENT-orators">
        <button className="bg-coal text-white px-10 md:px-20 py-2 rounded-full mt-6 text-sm md:text-base">
          View All
        </button>
      </Link>
    </div>
  );
};

export default Orators;